module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/arrow-down-0c8f1047b17a47109121deeb8888796a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/arrow-down.svg
// module id = Ifyr
// module chunks = 24